import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Observer } from "mobx-react";
import axios from "axios";
import LinearProgress from "../../components/LinearProgress";
import Footer from "./Footer";
import { getMobileOperatingSystem, hRatio } from "../../../constants/utils";
import QuestionareStore from "../../stores/QuestionareStore";
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { BackgroundIC } from "../../../procastination_flow/components/Background"
import { SlideIn } from "../../../new_onboarding/transitions/transitions";
import { AnimatePresence } from "framer-motion";
import IC_Component from "../../components/IC_Component";
import { useSearchParams } from "react-router-dom";
import { triggerEvent } from "../../../constants/utils";
import FooterHindi from "./FooterHindi";

const Questionare = () => {
  const navigate = useNavigate();
  const isiOS = getMobileOperatingSystem() === "iOS";
  const [metadata, setMetadata] = useState({});
  const [searchParams] = useSearchParams()
  const [icLabel, setIcLabel] = useState("")

  const ic_id = searchParams.get('ic')

  useEffect(()=>{
    if(ic_id){
      triggerEvent("Journey started! - ", {ic_id});
    }
    
  }, [ic_id])

  // console.log("ic_id from questionaire", ic_id)
  QuestionareStore.setJourneyId(ic_id);
  useEffect(() => {
    QuestionareStore.setNavigation(navigate);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        type: 'ic',
        content_id: ic_id,
      };

      const headers = {
        'no-encryption': 'True',
      };

      try{
        const response = await axios.get('https://api.evolveinc.in/api/v3/content/details', {
          params,
          headers
        });

        const ic_link = response.data.data?.content_details?.ic_link
        const ic_label = response.data.data?.content_details?.ic_label
        setIcLabel(ic_label)
        if(!ic_link) return;
        

        const proxiedUrl = ic_link;

        const content_data = await axios.get(proxiedUrl)
        const jsonData = content_data
        const questions_array = jsonData.data.ic
        
        // console.log("Final ic json: ",questions_array)
        QuestionareStore.setQuestions(questions_array)
      }
      catch(error){
        console.log("API fetch error: ", error)
      }
    };

    fetchData();

  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        type: 'ic',
        content_id: ic_id,
      };

      const headers = {
        'no-encryption': 'True',
      };

      try{
        const response = await axios.get('https://api.evolveinc.in/api/v3/content/details', {
          params,
          headers
        });

        const ic_link = response.data.data?.content_details?.ic_link
        if(!ic_link) return;

        
        const proxiedUrl = ic_link;

        const content_data = await axios.get(proxiedUrl)
        const jsonData = content_data
        const metadata = jsonData.data.metadata
        // console.log("Final ic metadata: ",metadata)
        setMetadata(metadata)
      }
      catch(error){
        console.log("API fetch error: ", error)
      }
    };

    fetchData();

  }, []);

  const isHindi = icLabel && icLabel.toLowerCase().includes("hindi")
  
  return (
    <Observer>
      {() => {
        let currentStepIndex = QuestionareStore.currentStepIndex;
        const questions = QuestionareStore.QUESTIONS;
        // console.log(metadata.cover_image)
        let item = questions[currentStepIndex];

        if(!questions || questions.length===0){
          return(
              <BackgroundIC backgroundImage={metadata.cover_image}>
                <div className={styles.Container}>
                  <div className={styles.BarContainer}>
                    <LinearProgress progress={0} />
                  </div>
                  <div className={styles.LoadingText}>Loading content...</div>
                </div>
              </BackgroundIC>
          );
        }
        const progress =
          (currentStepIndex / (QuestionareStore.QUESTIONS.length)) * 100;
        return (
          <BackgroundIC backgroundImage={metadata.cover_image}>
            <AnimatePresence>
              <div className={styles.Container}>
                
                  <>
                    <div className={styles.BarContainer}>
                      <LinearProgress progress={progress} />
                    </div>
                      <IC_Component 
                        key={QuestionareStore.currentStepIndex}
                        item={item}
                        isHindi={isHindi}
                      />
                      {/* <Footer isQuestionScreen={true}/> */}
                      {isHindi ? (
                        <FooterHindi isQuestionScreen={true} />
                      ) : (
                        <Footer isQuestionScreen={true} />
                      )}
                    
                  </>

              </div>
            </AnimatePresence>
          </BackgroundIC>
        );
      }}
    </Observer>
  );
};

export default Questionare;
